import { module } from 'stereomodularjs';
export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
            click: 'callModule'
        }
    }

    init() {
        this.moduleFn = this.el.getAttribute('data-function');
        this.moduleEl = this.el.getAttribute('data-target');
        this.moduleId = this.el.getAttribute('data-name');
    }

    callModule(e) {
        
        if (!this.moduleFn) {
            return;
        }
        if (!this.moduleEl) {
            return;
        }
        if (!this.moduleId) {
            return;
        }
        
        this.call(this.moduleFn, document.querySelector(this.moduleEl), this.moduleId);
        e.preventDefault();

    }
}
